import React, { useState, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { FormGroup, Label, Input } from "reactstrap";
import { useDebouncedEffect } from "../../hooks/useDebounceEffect";

export default function TextInput({
    id,
    schema,
    uiSchema,
    value,
    placeholder,
    required,
    disabled,
    readonly,
    autofocus,
    onChange: onChangeForm,
    onKeyChange,
    onBlur,
    onFocus,
}) {
    const [current, setCurrent] = useState(value);
    useDebouncedEffect(() => {
        if (current !== value) {
            onChangeForm(current)
        }
    }, [current], 450);

    useEffect(() => setCurrent(value), [value]);

    return (
        <FormGroup>
            <Input
                disabled={disabled}
                type="text"
                className="custom"
                value={current || ""}
                required={required}
                onChange={(e) => setCurrent(e.target.value)}
                readOnly={readonly}
                autoFocus={autofocus}
                id={id}
            />
        </FormGroup>
    );
}